import type { Rule } from 'antd/lib/form';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { toIsoDateString } from 'src/shared/utils';
import { validLivingDate } from 'src/shared/validatorUtils';

export const livingEndDateRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct living end date'),
    validator: (_, value: Dayjs) => (
      !value || validLivingDate(toIsoDateString(value.toDate()))
        ? Promise.resolve()
        : Promise.reject()
    ),
  });
};
